import React from 'react';
import Img from '../imgs/heroImg.jpg';

const HeroImg = () => {
    return (
        <div style={{ backgroundImage: `url(${Img})`, backgroundSize: 'cover', backgroundPosition: 'center', width: '40%', minHeight: '100vh' }} className='md:block hidden '>
        </div>
    );
};

export default HeroImg;